<template>
  <div>
    <div class="ui dividing header">
      {{ $t("serbipagos agreement setup") }}
    </div>
    <div class="fields">
      <div class="six wide column field">
        <label for>{{ $t("name") }}</label>
        <input type="text" name="name" v-model="setting.name" />
      </div>
      <div class="four wide column field">
        <label for>{{ $t("provider") }}</label>
        <input type="text" name="provider" v-model="setting.provider" />
      </div>
      <div class="four wide column field">
        <label for>{{ $t("code") }}</label>
        <input type="text" name="code" v-model="setting.code" />
      </div>
      <!-- <div class="seven wide field">
                    <div class="ui toggle checkbox">
                      <input
                        type="checkbox"
                        name="set_as_default"
                        v-model="setup.settings[idx].is_default"
                      />
                      <label>{{ $t("set as default") }}</label>
                    </div>
                  </div> -->
      <div class="two wide column field">
        <label for>{{ $t("delete") }}</label>
        <div
          class="ui red icon button"
          :data-tooltip="$t('delete')"
          @click="remove_setting"
        >
          <i class="trash icon"></i>
        </div>
      </div>
    </div>
    <h5 class="ui dividing header">{{ $t("integration") }}</h5>
    <div class="field">
      <label for="">{{ $t("file") }}</label>
      <div class="ui selection dropdown" ref="integration_file">
        <input type="hidden" name="integration_file" />
        <i class="dropdown icon"></i>
        <div class="default text">{{ $t("select one") }}</div>
        <div class="menu"></div>
      </div>
    </div>
    <!-- <div class="three fields">
      <div class="field">
        <label for="">{{ $t("query method") }}</label>
        <div class="ui selection dropdown" ref="query_method">
          <input type="hidden" name="query_method" />
          <i class="dropdown icon"></i>
          <div class="default text">{{ $t("select one") }}</div>
          <div class="menu"></div>
        </div>
      </div>
      <div class="field">
        <label for="">{{ $t("payment method") }}</label>
        <div class="ui selection dropdown" ref="payment_method">
          <input type="hidden" name="payment_method" />
          <i class="dropdown icon"></i>
          <div class="default text">{{ $t("select one") }}</div>
          <div class="menu"></div>
        </div>
      </div>
      <div class="field">
        <label for="">{{ $t("reverse method") }}</label>
        <div class="ui selection dropdown" ref="reverse_method">
          <input type="hidden" name="reverse_method" />
          <i class="dropdown icon"></i>
          <div class="default text">{{ $t("select one") }}</div>
          <div class="menu"></div>
        </div>
      </div>
    </div> -->
    <!-- <div class="ui two item top attached tabular menu" ref="tabss">
      <a class="active item" data-tab="identifiers">
        <i class="info icon"></i> {{ $t("identifiers") }}</a
      >
      <a class="item" data-tab="values">
        <i class="font icon"></i> {{ $t("values") }}</a
      >
    </div>
    <div class="ui bottom attached active tab segment" data-tab="identifiers">
      <h5 class="ui dividing header">{{ $t("identifiers") }}</h5>
      <div
        class="fields"
        v-for="(identifier, iidx) in setting.identifiers"
        :key="iidx"
      >
        <div class="two wide field">
          <label for="" v-show="iidx == 0">{{ $t("name") }}</label>
          <label for="">{{ setting.identifiers[iidx].name }}</label>          
        </div>
        <div class="eight wide field">
          <label for="" v-show="iidx == 0">{{ $t("large attribute") }}</label>
          <input type="text" v-model="setting.identifiers[iidx].large" />
        </div>
        <div class="six wide field">
          <label v-show="iidx == 0">{{ $t("short attribute") }}</label>
          <input type="text" v-model="setting.identifiers[iidx].short" />
        </div>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="values">
      <h5 class="ui dividing header">{{ $t("values") }}</h5>
      <div
        class="fields"
        v-for="(identifier, iidx) in setting.values"
        :key="iidx"
      >
        <div class="two wide field">
          <label for="" v-show="iidx == 0">{{ $t("name") }}</label>
          <label for="">{{ setting.values[iidx].name }}</label>          
        </div>
        <div class="eight wide field">
          <label for="" v-show="iidx == 0">{{ $t("large attribute") }}</label>
          <input type="text" v-model="setting.values[iidx].large" />
        </div>
        <div class="six wide field">
          <label v-show="iidx == 0">{{ $t("short attribute") }}</label>
          <input type="text" v-model="setting.values[iidx].short" />
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "",
  props: { setting: Object, index: Number, integration_files: Array },
  data() {
    return {};
  },
  methods: {
    remove_setting() {
      this.$emit("remove", this.index);
    },
    init_tabs() {
      let vm = this;
      window
        .jQuery(vm.$refs.tabss)
        .find(".item")
        .tab();

      let vls = vm.integration_files.map((rf) => {
        return { name: rf, value: rf };
      });

      window
        .jQuery(vm.$refs.integration_file)
        .dropdown("setup menu", { values: vls })
        .dropdown({
          onChange(value) {
            vm.setting.integration_file = value;
          },
        });

      if (vm.setting.integration_file)
        window
          .jQuery(vm.$refs.integration_file)
          .dropdown("set selected", vm.setting.integration_file);

      // window
      //   .jQuery(vm.$refs.query_method)
      //   .dropdown("setup menu", { values: vls })
      //   .dropdown({
      //     onChange(value) {
      //       vm.setting.query_integration = value;
      //     },
      //   });

      // if (vm.setting.query_integration)
      //   window
      //     .jQuery(vm.$refs.query_method)
      //     .dropdown("set selected", vm.setting.query_integration);

      // window
      //   .jQuery(vm.$refs.payment_method)
      //   .dropdown("setup menu", { values: vls })
      //   .dropdown({
      //     onChange(value) {
      //       vm.setting.payment_integration = value;
      //     },
      //   });

      // if (vm.setting.payment_integration)
      //   window
      //     .jQuery(vm.$refs.payment_method)
      //     .dropdown("set selected", vm.setting.payment_integration);

      // window
      //   .jQuery(vm.$refs.reverse_method)
      //   .dropdown("setup menu", { values: vls })
      //   .dropdown({
      //     onChange(value) {
      //       vm.setting.reverse_integration = value;
      //     },
      //   });

      // if (vm.setting.reverse_integration)
      //   window
      //     .jQuery(vm.$refs.reverse_method)
      //     .dropdown("set selected", vm.setting.reverse_integration);
    },
  },
};
</script>
